import App from './App.svelte';
import AbstractID from './AbstractID';
import { loadConfiguration } from './AppConfiguration';

AbstractID.initialize();
loadConfiguration();

const app = new App({
  target: document.getElementById('app')
});

export default app;
